import React from "react";
import { motion } from "framer-motion";
import { BrainIcon, ClockIcon } from "lucide-react";
import { ReasonIcon, urgencyReasons } from "../data/protocol";
const STYLES: Record<ReasonIcon, {
  Icon: typeof ClockIcon;
  border: string;
  circle: string;
  icon: string;
}> = {
  clock: {
    Icon: ClockIcon,
    border: "border-l-forest",
    circle: "bg-cream-dark",
    icon: "text-forest"
  },
  memory: {
    Icon: BrainIcon,
    border: "border-l-gold",
    circle: "bg-[#F4EBDA]",
    icon: "text-gold"
  }
};
export function UrgencyReasons() {
  return <section aria-labelledby="razones-title" className="mt-16" data-id="element-411" data-mp="1geo3de1fv14s">
      <h2 id="razones-title" className="text-center font-serif text-3xl font-semibold leading-tight text-forest sm:text-4xl" data-id="element-412" data-mp="1bmejaen08vaf">
        Por qué empezar esta misma noche
      </h2>
      <div className="mt-8 space-y-6" data-id="element-413" data-mp="17j8cn5vzd23f">
        {urgencyReasons.map((reason, i) => {
        const s = STYLES[reason.icon];
        return <motion.article key={reason.title} className={`flex flex-col gap-5 rounded-3xl border-l-4 bg-white p-6 shadow-sm sm:flex-row sm:items-start sm:gap-8 sm:p-8 ${s.border}`} initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: "-60px"
        }} transition={{
          duration: 0.3,
          delay: i * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-414" data-mp="1zb61qeaslza0" data-mpi={i}>
              <motion.span className={`flex h-20 w-20 shrink-0 items-center justify-center rounded-full ${s.circle}`} initial={{
            scale: 0.7
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            type: "spring",
            stiffness: 380,
            damping: 12,
            delay: 0.1 + i * 0.08
          }} data-id="element-415" data-mp="3foq7haomw6f6">
                <s.Icon className={`h-9 w-9 ${s.icon}`} aria-hidden="true" data-id="element-416" data-mp="3ar6uee3o9zot" />
              </motion.span>
              <div data-id="element-417" data-mp="13x33s61dotnh">
                <h3 className="font-serif text-xl font-semibold leading-snug text-cocoa sm:text-2xl" data-id="element-418" data-mp="18xqtmodvf4g4">{reason.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-cocoa-soft sm:text-lg" data-id="element-419" data-mp="17h3fijbq4abp">{reason.text}</p>
              </div>
            </motion.article>;
      })}
      </div>
    </section>;
}